module.exports = __webpack_public_path__ + "img/panel_1.c2d85c61.png";